import { MzImage } from '../MzImage';
import { Mapper, ReadOnly } from 'module/Common';
import { Localized } from 'module/Model/Localized';

export type PageListItem = ReadOnly<PageListItem.Shape>;

export namespace PageListItem {
  export type Shape = {
    id: number | null;
    date: Date | null;
    title: Localized<string> | null;
    categories: Array<number>;
    coverImg: MzImage | null;
  };

  const create = (input: PageListItem) => input;

  export const mapper = Mapper.mapSchema(
    {
      id: Mapper.num,
      date: Mapper.date,
      categories: Mapper.arrayOrEmptyIfNull(Mapper.num),
      title: Localized.mapperWithDefault('Sans Non', 'No Name'),
      cover_img: MzImage.mapper,
    },
    ({ id, date, title, categories, cover_img }) => create({ id, date, title, categories, coverImg: cover_img })
  );
}



// WEBPACK FOOTER //
// ./src/module/Model/PageList/PageListItem.ts